import { Outlet } from 'react-router-dom'
import { TopBar } from './top-bar'
import { Sidebar } from './sidebar'
import { useAuthStore } from '@/features/auth/stores/use-auth-store'
import { useProjectMembershipQuery } from '@/features/auth/hooks/use-project-membership-query'

export function AccountShell() {
  const user = useAuthStore((s) => s.user)
  const activeProjectId = useAuthStore((s) => s.activeProjectId)

  const { data: dbRole } = useProjectMembershipQuery(activeProjectId ?? undefined, user?.id)
  const resolvedRole = user?.isSuperUser ? 'super_user' : (dbRole ?? null)

  const userProps = user
    ? {
        name: user.name ?? user.email,
        email: user.email,
        initials: (user.name ?? user.email)
          .split(' ')
          .map((w) => w[0])
          .join('')
          .slice(0, 2)
          .toUpperCase(),
      }
    : undefined

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <TopBar projectId={activeProjectId ?? undefined} showProject={!!activeProjectId} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          activeKey="account"
          projectId={activeProjectId ?? undefined}
          role={resolvedRole}
          user={userProps}
        />
        <main className="flex-1 overflow-y-auto bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
